import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Cancel, SaveAlt, Save } from "@material-ui/icons";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import {
  Dialog,
  Grid,
  Button,
  TextField,
  Snackbar,
  Slide,
  AppBar,
  Tabs,
  Tab,
  Box,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import Papa from "papaparse";
import Moment from "moment";
import axios from "axios";

import LoadGender from "components/services/LoadGender";
import imgLoader from "assets/img/progress.gif";
import exampleCSV from "assets/img/exampleCSV.png";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
  };
}

export default function NewStudentAdmin(props) {
  const classes = useStyles();
  const theme = useTheme();

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [errorServer, setErrorServer] = useState(false);
  const [errorServerInternal, setErrorServerInternal] = useState(false);
  const [loaders, setLoaders] = useState(false);
  const [loadersStart, setloadersStart] = useState(false);
  const [loadersSave, setLoadersSave] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [disabledMasive, setDisabledMasive] = useState(true);
  const [rowsImport, setRowsImport] = useState([]);
  const [rowsAlert, setRowsAlert] = useState([]);
  const [rowsAlertData, setRowsAlertData] = useState([]);
  //const [rows, setRows] = useState([]);
  const [exitAlert, setExitAlert] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    fecha_emision: "",
    identificacion: "",
    nombres: "",
    //apellidos: "",
    tipo_estudios: "",
    programa_academico: "",
    gender_id: "",
    genderdata: [],
    gendername: "",
    email_personal: "",
    email_institucional: "",
    celular: "",
    telefono: "",
    fecha_nacimiento: "",
    inicio_clases: "",
    errorGender: false,
    errorNombres: false,
    //errorApellidos: false,
    errorEmailPersonal: false,
    errorIdentificacion: false,
    errorFechaEmision: false,
    errorFechaNacimiento: false,
    errorCelular: false,
  });

  /* useEffect(() => {
    dataRows();
  }, []);

  const dataRows = async () => {
    setloadersStart(true);

    try {
      await axios
        .get(
          `${urlServices}routes_student.php?keyAplication=${keyAplication}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.code === 1) {
            setRows(response.data.data);
            setloadersStart(false);
          } else if (response.data.code === 0) {
            setRows([]);
            setloadersStart(false);
          } else {
            setloadersStart(false);
            setMensaje("Error de conexión");
            setOpenAlert(true);
            setError("error");
          }
        })
        .catch((e) => {
          setRows([]);
          setError(true);
          setloadersStart(false);
          console.log(e);
        });
    } catch (error) {
      // console.log("ENTROOOOOOOO2");
      setError(true);
      setRows([]);
      setloadersStart(false);
      console.error(error);
      throw error;
    }
  };*/

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorNombres: false,
      //errorApellidos: false,
      errorEmailPersonal: false,
      errorCelular: false,
    });

    setDisabledMasive(false);
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setOpenAlert(false);
    setErrorServer(false);
    setErrorServerInternal(false);

    if (valueTabs === 0) {
      if (values.nombres.length === 0) {
        setValues({ ...values, errorNombres: true });
        setMensaje('El campo "Nombres" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } /* else if (values.apellidos.length === 0) {
        setValues({ ...values, errorApellidos: true });
        setMensaje('El campo "Apellidos" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      }*/ else if (values.identificacion.length === 0) {
        setValues({ ...values, errorIdentificacion: true });
        setMensaje('El campo "Identificación" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.fecha_emision === "") {
        setValues({ ...values, errorFechaEmision: true });
        setMensaje('El campo "Fecha de emisión" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.gendername.length === 0) {
        setValues({ ...values, errorGender: true });
        setMensaje('El campo "Género" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.fecha_nacimiento === "") {
        setValues({ ...values, errorFechaNacimiento: true });
        setMensaje('El campo "Fecha de nacimiento" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.email_personal.length === 0) {
        setValues({ ...values, errorEmailPersonal: true });
        setMensaje('El campo "Correo personal" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else if (values.celular.length === 0) {
        setValues({ ...values, errorCelular: true });
        setMensaje('El campo "Un celular" es obligatorio.');
        setOpenAlert(true);
        setError("error");
      } else {
        setLoaders(true);

        const dataValue = {
          fecha_emision: values.fecha_emision,
          identificacion: values.identificacion,
          nombres: values.nombres,
          // apellidos: values.apellidos,
          tipo_estudios: values.tipo_estudios,
          programa_academico: values.programa_academico,
          gender_id: values.gender_id,
          email_personal: values.email_personal,
          email_institucional: values.email_institucional,
          celular: values.celular,
          telefono: values.telefono,
          fecha_nacimiento: values.fecha_nacimiento,
          inicio_clases: values.inicio_clases,
          keyAplication: keyAplication,
        };

        axios
          .post(`${urlServices}routes_studentinsert.php`, dataValue, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            if (response.data.code === 1) {
              setLoaders(false);

              setValues({
                ...values,
                fecha_emision: "",
                identificacion: "",
                nombres: "",
                // apellidos: "",
                tipo_estudios: "",
                programa_academico: "",
                gender_id: "",
                genderdata: [],
                gendername: "",
                email_personal: "",
                email_institucional: "",
                celular: "",
                telefono: "",
                fecha_nacimiento: "",
                inicio_clases: "",
              });

              setOpenAlert(true);
              setMensaje("Registro guardado con éxito.");
              setError("success");

              props.callBackRefresh();
            } else if (response.data.code === 0) {
              setLoaders(false);

              setMensaje("Error al registrar los datos.");
              setOpenAlert(true);
              setError("error");
            }
          })
          .catch((e) => {
            setLoaders(false);

            setMensaje("Error de conexión, intente más tarde.");
            setOpenAlert(true);
            setError("error");
            setErrorServer(true);
          });
      }
    } else if (valueTabs === 1) {
      setLoadersSave(true);

      let dataApplicants = rowsImport.length,
        n = 0;

      if (dataApplicants > 0) {
        setTimeout(() => {
          // rowsImport.map((row1) => {
          //   const insert = async () => {
          // row1.keyAplication = keyAplication;

          const datos = {
            keyAplication: keyAplication,
            data: rowsImport,
          };

          // await axios
          axios
            .post(`${urlServices}routes_studentinsertmultiples.php`, datos, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then(
              (response) => {
                if (response.data.code === 1) {
                  setOpenAlert(true);
                  setMensaje("Datos registrados con éxito.");

                  setRowsImport([]);
                  setValueTabs(0);
                  setDisabledMasive(true);
                  setLoadersSave(false);

                  setTimeout(() => {
                    props.callBackRefresh();
                  }, 1500);
                } else if (response.data.code === 0) {
                } else {
                }
              },
              (error) => {
                console.log("ERROR EN EL REGISTRO", error);
                setErrorServerInternal(true);
                setLoadersSave(false);
              },
            );
          // };

          //  insert();
          //  n++;
          //  });
        }, 1000);

        /*if (n === dataApplicants) {
          setOpenAlert(true);
          setMensaje("Datos registrados con éxito.");

          setRowsImport([]);
          setValueTabs(0);
          setDisabledMasive(true);
          setLoadersSave(false);

          setTimeout(() => {
            props.callBackRefresh();
          }, 1500);
        }*/
      } else {
        setLoadersSave(false);
        setMensaje("El archivo no puede estar vacío.");
        setOpenAlert(true);
        setError("error");
      }
    }
  };

  const searchIndentificacion = async (data) => {
    await axios
      .get(
        `${urlServices}routes_studentdocument.php?document=${data}&keyAplication=${keyAplication}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        if (response.data.code === 1) {
          setDisabledMasive(true);
          setValues({ ...values, errorIdentificacion: true });
          setMensaje("Estudiante ya registrado con esta identificación.");
          setOpenAlert(true);
          setError("error");
        } else if (response.data.code === 0) {
          setDisabledMasive(false);
        }
      })
      .catch((e) => {
        setError(true);
      });
  };

  const arrayDNY = (data) => {
    if (data.length > 0) {
      return (
        <Fragment>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableBody>
                <TableRow style={{ backgroundColor: "#F2F2F2" }}>
                  <TableCell
                    colSpan={9}
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    HAY QUE ELIMINAR ESTOS DATOS DEL DOCUMENTO QUE DESEA SUBIR
                  </TableCell>
                </TableRow>
                <TableRow style={{ backgroundColor: "tomato" }}>
                  <TableCell
                    colSpan={9}
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                    }}
                  >
                    ESTAS CÉDULAS YA ESTÁN REGISTRADAS CON ESTOS USUARIOS EN EL
                    SISTEMA
                  </TableCell>
                </TableRow>
                <TableRow className={classes.titleFilterAction}>
                  <TableCell
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: 14,
                      backgroundColor: "#F2F2F2",
                    }}
                  >
                    Cédula
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      fontSize: 14,
                      backgroundColor: "#F2F2F2",
                    }}
                  >
                    Nombres
                  </TableCell>
                </TableRow>
                {data.map((row, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell
                        style={{
                          textAlign: "center",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {row.identificacion}
                      </TableCell>
                      <TableCell
                        style={{
                          textAlign: "center",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {row.nombre}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      );
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleDateNacimientoChange = (e) => {
    setValues({
      ...values,
      fecha_nacimiento: e.target.value,
      errorFechaNacimiento: false,
    });
  };

  const handleDateEmisionChange = (e) => {
    setValues({
      ...values,
      fecha_emision: e.target.value,
      errorFechaEmision: false,
    });
  };

  const handleDateInicioClasesChange = (e) => {
    setValues({
      ...values,
      inicio_clases: e.target.value,
    });
  };

  const handleIndentificacionChange = (e) => {
    setValues({
      ...values,
      identificacion: e.target.value,
      errorIdentificacion: false,
    });

    searchIndentificacion(e.target.value);
  };

  const changeGender = (data) => {
    setValues({
      ...values,
      gender_id: data !== null ? data.id : "",
      gendername: data !== null ? data.name : "",
      genderdata: data !== null ? data : [],
      errorGender: false,
    });
  };

  const handleChangeIndex = (index) => {
    setValueTabs(index);
  };

  const handleChangeTabs = (event, newValue) => {
    setValues({
      ...values,
      fecha_emision: "",
      identificacion: "",
      nombres: "",
      // apellidos: "",
      tipo_estudios: "",
      programa_academico: "",
      gender_id: "",
      genderdata: [],
      gendername: "",
      email_personal: "",
      email_institucional: "",
      celular: "",
      telefono: "",
      fecha_nacimiento: "",
      inicio_clases: "",
    });

    setDisabledMasive(true);
    setValueTabs(newValue);
  };

  const changeHandler = (event) => {
    setOpenAlert(false);
    setRowsAlert(false);
    setRowsAlertData([]);

    if (event.target.files[0] !== undefined) {
      // Passing file data (event.target.files[0]) to parse using Papa.parse
      Papa.parse(event.target.files[0], {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          const rowsArray = [];
          const valuesArray = [];
          const out = [];
          const empty = [];

          // Iterating data to get column name and their values
          results.data.map((d) => {
            rowsArray.push(Object.keys(d));
            valuesArray.push(Object.values(d));
          });

          // Parsed Data Response in array format
          // setParsedData(results.data);

          // Filtered Column Names
          // setTableRows(rowsArray[0]);

          // Filtered Values
          // setValues(valuesArray);

          results.data.map((row1) => {
            /*console.log("INICIO",row1.Fecha_Emision.length);
            console.log("Fecha_Emision",row1.Identificacion.length);
            console.log("Fecha_Emision",row1.Nombre.length);
            console.log("Fecha_Emision",row1.Apellido.length);
            console.log("Fecha_Emision",row1.Tipo_Estudios.length);
            console.log("Fecha_Emision",row1.Programa_Academico.length);
            console.log("Fecha_Emision",row1.Genero.length);
            console.log("Fecha_Emision",row1.Correo_Personal.length);
            console.log("Fecha_Emision",row1.Correo_Institucional.length);
            console.log("Fecha_Emision",row1.Celular.length);
            console.log("Fecha_Emision",row1.Telefono.length);
            console.log("Fecha_Emision",row1.Fecha_Nacimiento.length);
            console.log("FINAL",row1.Inicio_Clases.length);*/
            const tieneDatos = Object.values(row1).some(
              (elemento) => elemento !== "",
            );

            if (tieneDatos) {
              if (
                row1.Identificacion === "" ||
                row1.Identificacion === undefined
              ) {
                empty.push({ identificacion: true });
              }

              if (row1.Nombre === "" || row1.Nombre === undefined) {
                empty.push({ nombre: true });
              }

              /*if (row1.Apellido === "") {
                empty.push({ apellido: true });
              }*/

              if (row1.Genero === "" || row1.Genero === undefined) {
                empty.push({ genero: true });
              }

              if (
                Moment(row1.Fecha_Emision).format("YYYY-MM-DD") ===
                  "Invalid date" ||
                row1.Fecha_Emision === undefined
              ) {
                empty.push({ Fecha_Emision: true });
              }

              if (
                Moment(row1.Fecha_Nacimiento).format("YYYY-MM-DD") ===
                  "Invalid date" ||
                row1.Fecha_Nacimiento === undefined
              ) {
                empty.push({ Fecha_Nacimiento: true });
              }

              if (
                Moment(row1.Inicio_Clases).format("YYYY-MM-DD") ===
                  "Invalid date" ||
                row1.Inicio_Clases === undefined
              ) {
                empty.push({ Inicio_Clases: true });
              }

              const valuesNuew = {
                fecha_emision: row1.Fecha_Emision,
                identificacion: row1.Identificacion,
                nombres: row1.Nombre,
                //apellidos: row1.Apellido,
                tipo_estudios: row1.Tipo_Estudios,
                programa_academico: row1.Programa_Academico,
                gender_id: row1.Genero === "M" ? 1 : 2,
                email_personal: row1.Correo_Personal,
                email_institucional: row1.Correo_Institucional,
                celular: row1.Celular,
                telefono: row1.Telefono,
                fecha_nacimiento: row1.Fecha_Nacimiento,
                inicio_clases: row1.Inicio_Clases,
              };

              out.push(valuesNuew);
            }
          });

          if (empty.length > 0) {
            setExitAlert(true);
            setMensaje(
              "Hay celdas vacías o formato de fecha no aceptada que son obligatoria para registrar, revise las columnas FECHA EMISION con formato 2024-01-01, FECHA NACIMIENTO con formato 2024-01-01, FECHA INICIO CLASES con formato 2024-01-01, no se permite formato 1900-01-00, IDENTIFICACION = no vacío, NOMBRE = no vacío  Y GENERO = no vacío o verifique que no haya modificado la cabecera del formato original.",
            );
            setOpenAlert(true);
            setError("error");
          } else if (out.length === 0) {
            setExitAlert(true);
            setMensaje(
              "El documento no puede estar vacío o revisar que estén todos los datos obligatorios.",
            );
            setOpenAlert(true);
            setError("error");
          } else {
            /* let datos = [];
            let datosIgual = [];

            rows.map((row2) => {
              datos = out.filter(
                (filtered) => filtered.identificacion === row2.identificacion
              );

              if (datos.length > 0) {
                datosIgual.push({
                  identificacion: row2.identificacion,
                  nombre: row2.nombres,
                  // apellido: row2.apellidos,
                });
              }
            });

            if (datosIgual.length === 0) {*/
            setRowsImport(out);
            setDisabledMasive(false);
            /*} else {
              setExitAlert(true);
              setRowsAlert(true);
              setRowsAlertData(datosIgual);
            }*/
          }
        },
      });
    }
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>
                  Nuevo estudiante(s)
                </div>
                <div className={classes.lineBottom}></div>
                <br></br>
              </Grid>
              {loadersStart ? (
                <Grid item xs={12} md={12}>
                  <center>
                    <img
                      src={imgLoader}
                      alt="loader"
                      style={{
                        width: 60,
                        objectFit: "contain",
                        marginTop: 25,
                      }}
                    />
                  </center>
                </Grid>
              ) : (
                <Grid item xs={12} md={12}>
                  <AppBar position="static" color="default">
                    <Tabs
                      value={valueTabs}
                      onChange={handleChangeTabs}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="fullWidth"
                      aria-label="action tabs example"
                    >
                      <Tab
                        label="Carga manual"
                        {...a11yProps(0)}
                        style={{ color: "#000" }}
                      />
                      <Tab
                        label="Carga masiva"
                        {...a11yProps(1)}
                        style={{ color: "#000" }}
                      />
                    </Tabs>
                  </AppBar>
                  <SwipeableViews
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={valueTabs}
                    onChangeIndex={handleChangeIndex}
                  >
                    <TabPanel value={valueTabs} index={0} dir={theme.direction}>
                      <Grid
                        container
                        spacing={3}
                        style={{
                          backgroundColor: "#f8f8f8",
                          borderRadius: 5,
                          padding: 10,
                        }}
                      >
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="nombres"
                            value={values.nombres}
                            onChange={handleChange("nombres")}
                            label="Nombres"
                            error={values.errorNombres}
                            fullWidth
                            required
                          />
                        </Grid>
                        {/*<Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="apellidos"
                            value={values.apellidos}
                            onChange={handleChange("apellidos")}
                            label="Apellidos"
                            error={values.errorApellidos}
                            fullWidth
                            required
                          />
                        </Grid>*/}
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="date"
                            label="Fecha de emisión"
                            type="date"
                            value={values.fecha_emision}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => handleDateEmisionChange(e)}
                            autoComplete="off"
                            error={values.errorFechaEmision}
                            required
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="identificacion"
                            value={values.identificacion}
                            onChange={handleIndentificacionChange}
                            label="Identificación"
                            error={values.errorIdentificacion}
                            fullWidth
                            required
                            type="number"
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <LoadGender
                            refresh={changeGender}
                            value={values.genderdata}
                            error={values.errorGender}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="date"
                            label="Fecha de nacimiento"
                            type="date"
                            value={values.fecha_nacimiento}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => handleDateNacimientoChange(e)}
                            autoComplete="off"
                            error={values.errorFechaNacimiento}
                            required
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="email_personal"
                            value={values.email_personal}
                            onChange={handleChange("email_personal")}
                            label="Correo personal"
                            error={values.errorEmailPersonal}
                            fullWidth
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="email_institucional"
                            value={values.email_institucional}
                            onChange={handleChange("email_institucional")}
                            label="Correo institucional"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="date"
                            label="Inicio de clases"
                            type="date"
                            value={values.inicio_clases}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            onChange={(e) => handleDateInicioClasesChange(e)}
                            autoComplete="off"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="celular"
                            value={values.celular}
                            onChange={handleChange("celular")}
                            label="celular"
                            fullWidth
                            type="number"
                            error={values.errorCelular}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="telefono"
                            value={values.telefono}
                            onChange={handleChange("telefono")}
                            label="Teléfono"
                            fullWidth
                            type="number"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="tipo_estudios"
                            value={values.tipo_estudios}
                            onChange={handleChange("tipo_estudios")}
                            label="Tipo estudios"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            autoComplete="off"
                            name="programa_academico"
                            value={values.programa_academico}
                            onChange={handleChange("programa_academico")}
                            label="Programa académico"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          {errorServer && (
                            <Alert severity="error">
                              Error en la consulta al servidor
                            </Alert>
                          )}
                        </Grid>
                      </Grid>
                    </TabPanel>
                    <TabPanel value={valueTabs} index={1} dir={theme.direction}>
                      <Grid
                        container
                        spacing={1}
                        style={{
                          backgroundColor: "#f8f8f8",
                          borderRadius: 5,
                          padding: 10,
                        }}
                      >
                        <Grid item xs={12} md={12}>
                          <Alert severity="warning">
                            <AlertTitle>IMPORTANTE</AlertTitle>- La
                            columna&nbsp;
                            <strong>
                              Fecha Emisión, Fecha de nacimiento y Inicio Clases
                            </strong>{" "}
                            es importante mantener este formato ej:{" "}
                            <strong>2000-10-20</strong> seleccionando formato de
                            celdas "Fecha" en el excel, no se permite formato
                            1900-01-00.
                            <br></br>- La columna{" "}
                            <strong>Identificación, Celular y Teléfono</strong>{" "}
                            es importante mantener este formato ej: en formato
                            de "TEXTO" para agregar al inicio 0 si lo requiere.{" "}
                            <br></br>- La columna <strong>Género</strong> es
                            importante mantener este formato ej:{" "}
                            <strong>M o F</strong> donde M = Masculino y F =
                            Femenino. <br></br>- Al finalizar con el archivo
                            excel, deberá ir a{" "}
                            <strong>"ARCHIVO y GUARDAR COMO"</strong>,
                            seleccionar el formato del archivo tipo&nbsp;
                            <strong>
                              "(CSV CODIFICADO EN UTF-8 (DELIMITADO POR
                              COMAS))"{" "}
                            </strong>
                            y <strong>"GUARDAR"</strong>.<br></br>
                            <br></br>
                            <b>Ejemplo:</b>
                            <center>
                              <img
                                src={exampleCSV}
                                alt="example"
                                style={{
                                  width: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            </center>
                          </Alert>
                        </Grid>
                        <Grid item xs={12} md={12} style={{ marginTop: "3%" }}>
                          {rowsAlert ? arrayDNY(rowsAlertData) : null}
                        </Grid>
                        <br></br>
                        <br></br>
                        <Grid item xs={12} md={12}>
                          <center>
                            {exitAlert ? (
                              <Alert variant="filled" severity="error">
                                <b>
                                  Cierre nuevamente la ventana para evitar
                                  errores.
                                </b>
                              </Alert>
                            ) : null}
                          </center>
                        </Grid>
                        <br></br>
                        <br></br>
                        <Fragment>
                          <Grid item xs={12} md={12}>
                            <center>
                              <input
                                accept=".csv"
                                style={{ display: "none" }}
                                onChange={changeHandler}
                                id="contained-button-file"
                                multiple
                                type="file"
                                name="filecsv"
                              />
                              <a
                                href={"/document/csv_estudiantes.csv"}
                                download="csv_estudiantes.csv"
                              >
                                <Button
                                  className={classes.buttonLeftSteps2}
                                  startIcon={<SaveAlt />}
                                >
                                  Descargar formato
                                </Button>
                              </a>
                              <label htmlFor="contained-button-file">
                                <Button
                                  className={classes.buttonContactGreen}
                                  component="span"
                                >
                                  Subir documento
                                </Button>
                              </label>
                              <br></br>
                              <br></br>
                            </center>
                          </Grid>
                        </Fragment>
                      </Grid>
                    </TabPanel>
                  </SwipeableViews>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                {loadersStart ? null : (
                  <>
                    {loaders ? (
                      <center>
                        <img
                          src={imgLoader}
                          alt="loader"
                          style={{
                            width: 60,
                            objectFit: "contain",
                            marginTop: 25,
                          }}
                        />
                      </center>
                    ) : (
                      <Fragment>
                        {loadersSave && (
                          <center>
                            <img
                              src={imgLoader}
                              alt="loader"
                              style={{
                                width: 60,
                                objectFit: "contain",
                                marginTop: 25,
                              }}
                            />
                          </center>
                        )}

                        {errorServerInternal && (
                          <center>
                            <b style={{ color: "red" }}>
                              {" "}
                              Hay un error interno en el registro.
                            </b>
                          </center>
                        )}

                        {!loadersSave && !errorServerInternal && (
                          <center>
                            <Button
                              className={classes.buttonSubmit2}
                              onClick={submitForm}
                              disabled={disabledMasive}
                              startIcon={<Save />}
                            >
                              Guardar
                            </Button>
                          </center>
                        )}
                      </Fragment>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={20000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === "error" ? "error" : "success"}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
